const indiaSeoData = {
    '/': {
        description: "Order Pizza online from Domino’s and get a discount upto 50%. Choose from the best pizza deals and offers available online. Pizza Delivery, Takeaway and Dine-in available.",
        title: "Order Domino’s Pizza Online – Get 2 Regular Pizza @99 Each",
        keywords: "Domino's Pizza"
    },
    '/menu': {
        description: "Domino's is OPEN to serve you. Order all your favorite pizzas and we will ensure Zero contact delivery for all order",
        title: "Domino's ZERO Contact Delivery - Great Taste, Delivered Safe",
        keywords: "Domino's Pizza"
    },
    '/menu/veg-pizza': {
        description: "Select your favourite veg pizza from the Domino's Pizza menu. Order hot & fresh veggie pizzas online with your choice of crust & toppings. Free home delivery. Call now",
        title: "Domino's Veg Pizza Menu | Order Veggie Pizzas Online - Domino's Pizza India",
        keywords: "Domino's Pizza"
    },
    '/menu/pasta-pizza-party': {
        description: "Try and order Domino's new pasta pizza with jalapeno and harissa sauce loaded with creamy tomato, cheesy Jalapeno, paneer tikka masala pasta, capsicum,  cruncy bell peppers, olive, creamy culinary dressing, arsley sprinkle and BBQ chicken.",
        title: "Domino's Pasta - Order Pizza Pasta, Red & White Sauce Pasta Online",
        keywords: "Pasta Pizza, Pasta Pizza Party, Pasta masala pizza"
    },
    '/menu/non-veg-pizza': {
        description: "elect your favourite non-veg pizzas from the Domino's Pizza menu. Order hot & fresh non-veg pizzas online with your choice of crust & toppings. Free home delivery. Call now",
        title: "Domino's Non-Veg Pizza Menu | Order Non-Veg Pizzas Online - Domino's Pizza India",
        keywords: "Domino's Pizza"
    },
    '/menu/combos': {
        description: "Order your favorite combo meal from Domino's Online and get delivered in 30 Minutes*. Select your favorite Veg/Non-Veg Pizzas and get the best deals/coupons online.",
        title: "Meals & Combo - Order Veg/Non-Veg Pizzas, Garlic Bread, Pepsi starting @199",
        keywords: "Domino's Pizza"
    },
    '/menu/pizza-mania': {
        description: "Enjoy Delicious Pizza Mania Range Starting from Rs.44, Order Online or Call for Takeaway or Free Home Delivery.",
        title: "Pizza Mania",
        keywords: "Domino's Pizza"
    },
    '/menu/speciality-chicken': {
        description: "Winner winner, chicken dinner!! Enjoy delicious roast chicken, fried chicken and chicken wings from variety of chicken dishes starting from only Rs 109. Order Domino's chicken online to get free home delivery. Call now",
        title: "Dominos Chicken wings & Fried Chicken Starting From Rs.109 Only - Domino's India",
        keywords: "Domino's Pizza"
    },
    '/menu/sides': {
        description: "Explore Dominos side orders menu online like breads, pastas, dips, desserts & more. And get your favourite side order at Dominos. Free home delivery Order Now",
        title: "Dominos Side Orders Menu: Breads | Pastas | Dips | Desserts | More - Domino's Pizza India",
        keywords: "Domino's Pizza"
    },
    '/menu/beverages': {
        description: "Order your delicious Domino's pizzas with refreshing beverages like Coke, Fanta, Sprite and much more! Select your beverage from the Domino's Beverage Menu",
        title: "Domino's Beverage Menu - Enjoy Dominos Pizzas with your favorite beverages",
        keywords: "Domino's Pizza"
    },
    '/menu/dessert': {
        description: "Desserts are edible love! Whether its a fluffy butterscotch mousse or a molten chocolate lava cake or you're just simply craving some gooey chocolate brownies, we've got it all for you. Enjoy the delicious desserts from the domino's pizza menu to get the \"All's well that ends well\" feeling.",
        title:"Domino's Side Orders Menu | Desserts | Lava Cake, Butterscotch Mousse Cake & Brownie Fantasy - Domino's India",
        keywords: "Domino's Pizza"
    },
    '/offers': {
        description: "Get Upto 50% Instant Discount on Pizzas. Additional Cashback and saving via our payment partners - Amazon, Paytm, ICICI Banks & Others.",
        title: "Domino's Pizza Coupon & Offers: Get 2 Pizzas at 99 each",
        keywords: "Domino's Coupons, Offers"
    },
    '/edv': {
        description: "Everyday Value Offers | 2 Regular Pizzas @ Rs. 99 each | Domino's Pizza India",
        title: "Everyday Value Offers | 2 Regular Pizzas @ Rs. 99 each | Domino's Pizza India",
        keywords: "Domino's Pizza"
    }
};

module.exports = indiaSeoData;
